import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import CalloutBox from 'components/Docs/CalloutBox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`pip install posthog
`}</code></pre>

    <CalloutBox icon="IconInfo" title="Upgrading to v6" type="fyi" mdxType="CalloutBox">
      <p>{`Version `}<inlineCode parentName="p">{`6.x`}</inlineCode>{` of the PostHog Python SDK introduces a new `}<a parentName="p" {...{
          "href": "/docs/libraries/python#contexts"
        }}>{`contexts`}</a>{` API and breaking changes. If you're upgrading from `}<inlineCode parentName="p">{`5.x`}</inlineCode>{` to `}<inlineCode parentName="p">{`6.x`}</inlineCode>{`, read the `}<a parentName="p" {...{
          "href": "/tutorials/python-v6-migration"
        }}>{`migration guide`}</a>{` first to learn more.`}</p>
    </CalloutBox>
    <p>{`In your app, import the `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` library and set your project API key and host `}<strong parentName="p">{`before`}</strong>{` making any calls.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from posthog import Posthog

posthog = Posthog('<ph_project_api_key>', host='<ph_client_api_host>')
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` As a rule of thumb, we do not recommend having API keys in plaintext. Setting it as an environment variable is best.`}</p>
    </blockquote>
    <p>{`You can find your project API key and instance address in the `}<a parentName="p" {...{
        "href": "https://app.posthog.com/project/settings"
      }}>{`project settings`}</a>{` page in PostHog.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      